/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      // Новый воркер установлен. Благодаря skipWaiting+clientsClaim он активируется
      // и берёт управление сразу — дальше controllerchange ниже сам перезагрузит
      // страницу один раз на свежие ассеты.
      console.log('New content is available; switching to the new version.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })

  // Когда новый воркер перехватил управление (clientsClaim) — один раз перезагружаем
  // страницу, чтобы обычный reload показывал свежую сборку, а не старый кэш до закрытия
  // всех вкладок. refreshing защищает от петли перезагрузок.
  //
  // hadController: у первого визита (воркер ставится впервые) controller на момент
  // загрузки ещё null, и controllerchange от самого первого clientsClaim дал бы
  // лишний reload на пустом месте. Перезагружаемся только когда контроллер СМЕНИЛСЯ
  // у уже управляемой страницы — то есть приехала новая сборка.
  const hadController = !!navigator.serviceWorker?.controller
  let refreshing = false
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    if (!hadController || refreshing) return
    refreshing = true
    window.location.reload()
  })
}
